const API_BASE = "http://localhost:4000";

// ---- helpers ----
const TOKEN_KEY = "tm_token";
const USER_KEY = "tm_user";

export const getToken = () => localStorage.getItem(TOKEN_KEY);

export const getStoredUser = () => {
  const raw = localStorage.getItem(USER_KEY);
  return raw ? JSON.parse(raw) : null;
};

export const saveAuth = ({ token, user }) => {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USER_KEY, JSON.stringify(user));
};

export const clearAuth = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
};

const apiFetch = async (path, { method = "GET", body, token } = {}) => {
  const headers = { "Content-Type": "application/json" };
  if (token) headers.Authorization = `Bearer ${token}`;

  const res = await fetch(`${API_BASE}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });

  const data = await res.json().catch(() => null);

  if (!res.ok) {
    const message = data?.message || `Request failed (${res.status})`;
    const err = new Error(message);
    err.status = res.status;
    err.data = data;
    throw err;
  }

  return data;
};

// ---- auth ----
export const registerUser = (payload) =>
  apiFetch("/api/auth/register", { method: "POST", body: payload });

export const loginUser = (payload) =>
  apiFetch("/api/auth/login", { method: "POST", body: payload });

// ---- tasks (protected) ----
export const getTasks = async () => {
  const token = getToken();
  return apiFetch("/api/tasks", { token });
};

export const createTask = async (task) => {
  const token = getToken();
  return apiFetch("/api/tasks", { method: "POST", body: task, token });
};

export const deleteTask = async (id) => {
  const token = getToken();
  return apiFetch(`/api/tasks/${id}`, { method: "DELETE", token });
};